import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXBnsJX4eziyCKMvOIztqqnh2kl-UqziQ",
  authDomain: "meettix-2e2bc.firebaseapp.com",
  projectId: "meettix-2e2bc",
  storageBucket: "meettix-2e2bc.firebasestorage.app",
  messagingSenderId: "964229281680",
  appId: "1:964229281680:web:844843e6de9528ead12515",
  measurementId: "G-9LPC9CBMR2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Analytics helper function
export const logAnalyticsEvent = (eventName: string, eventParams?: Record<string, any>) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    console.error('Error logging analytics event:', error);
  }
};

export default app;